import { css } from '@emotion/react';

export function safeAreaInsetTop(value = '0px') {
  return css`
    padding-top: calc(constant(safe-area-inset-top) + ${value});
    padding-top: calc(env(safe-area-inset-top) + ${value});
  `;
}

export function safeAreaInsetBottom(value = '0px') {
  return css`
    padding-bottom: calc(constant(safe-area-inset-bottom) + ${value});
    padding-bottom: calc(env(safe-area-inset-bottom) + ${value});
  `;
}
